import ButtonSpinner from '../ButtonSpinner'

interface ButtonProps {
  disabled?: boolean
  onClick: () => void
  submitting?: boolean
  title: string
  type: 'primary' | 'primary-large' | 'secondary'
  dataTestId?: string
}

export default function Button({
  disabled = false,
  onClick,
  submitting = false,
  title,
  type,
  dataTestId,
}: ButtonProps) {
  const getButtonSpinnerClassName = () => {
    return type === 'secondary' ? 'text-black!' : 'text-white!'
  }

  const getClassName = () => {
    switch (type) {
      case 'primary':
        return 'inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-black bg-black p-4 text-white cursor-pointer hover:opacity-70 disabled:opacity-30'
      case 'primary-large':
        return 'inline-flex w-full items-center justify-center gap-2 rounded-lg bg-black p-6 text-lg font-bold uppercase text-white cursor-pointer hover:opacity-70 disabled:opacity-30'
      case 'secondary':
        return 'inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-black bg-white p-4 text-black cursor-pointer hover:opacity-50 disabled:opacity-30'
    }
  }

  return (
    <button
      className={getClassName()}
      disabled={disabled || submitting}
      onClick={onClick}
      title={title}
      data-testid={dataTestId}
    >
      {submitting && <ButtonSpinner className={getButtonSpinnerClassName()} />}

      {title}
    </button>
  )
}
